/* =========================
 * GLOBAL API CONFIG
 * ========================= */
/* =========================
 * AUTH MODULE
 * ========================= */
export const NotificationApiPath = {
    HISTORY: "/notification/facade/history",
};
export const AuthApiPath = {
    LOGIN: "/auth/login",
    PORTAL_LOGIN: "/auth/portal/login",
    REFRESH_TOKEN: "/auth/refresh",
    PORTAL_REFRESH_TOKEN: "/auth/portal/refresh",
    LOGOUT: "/auth/logout",
    PORTAL_LOGOUT: "/auth/portal/logout",
    ME: "/auth/me",
    MFA_VERIFY: "/auth/mfa/verify",
    MFA_RESEND: "/auth/mfa/resend",
    MFA_SETUP: "/auth/mfa/setup",
    MFA_ENABLE: "/auth/mfa/enable",
    MFA_DISABLE: "/auth/mfa/disable",
    SWITCH_BRANCH: "/auth/switch-branch",
};
/* =========================
 * MASTER MODULE
 * ========================= */
export const BASE_MASTER = "/master";
export const BASE_MASTER_COMMON = BASE_MASTER + "/common/facade";
export const BASE_MASTER_FINANCE = BASE_MASTER + "/finance/facade";
export const BASE_MASTER_EDU = BASE_MASTER + "/edu/facade";
// Master Common
export const KodeKotaApiPath = BASE_MASTER_COMMON + "/kodekota";
export const KodePosApiPath = BASE_MASTER_COMMON + "/kodepos";
export const KodeNegaraApiPath = BASE_MASTER_COMMON + "/kodenegara";
export const KodeAsuransiApiPath = BASE_MASTER_COMMON + "/kodeasuransi";
export const KodeBankApiPath = BASE_MASTER_COMMON + "/kodebank";
export const KodeGelarApiPath = BASE_MASTER_COMMON + "/kodegelar";
export const KodePekerjaanApiPath = BASE_MASTER_COMMON + "/kodepekerjaan";
export const KodePemasokApiPath = BASE_MASTER_COMMON + "/kodepemasok";
export const KodeDnominasiApiPath = BASE_MASTER_COMMON + "/kodednominasi";
export const KodeValasApiPath = BASE_MASTER_COMMON + "/kodevalas";
// Master Finance (Sandibi)
export const SandiBiSumberDanaApiPath = BASE_MASTER_FINANCE + "/sandibisumberdana";
export const SandiBiPihak3SlikApiPath = BASE_MASTER_FINANCE + "/sandibipihak3slik";
export const SandiBiJenisPenggunaanSlikApiPath = BASE_MASTER_FINANCE + "/sandibijenispenggunaanslik";
export const SandiBiJenisPenggunaanApiPath = BASE_MASTER_FINANCE + "/sandibijenispenggunaan";
export const SandiBiSektorEkonomiSlikApiPath = BASE_MASTER_FINANCE + "/sandibisektorekonomislik";
export const SandiBiKategoriDebiturSlikApiPath = BASE_MASTER_FINANCE + "/sandibikategoridebiturslik";
export const SandiBiSektorEkonomiOboxApiPath = BASE_MASTER_FINANCE + "/sandibisektorekonomiobox";
export const SandiBiJenisKreditSlikApiPath = BASE_MASTER_FINANCE + "/sandibijeniskreditslik";
export const SandiBiSifatSlikApiPath = BASE_MASTER_FINANCE + "/sandibisifatslik";
export const SandiBiOrientasiPenggunaanSlikApiPath = BASE_MASTER_FINANCE + "/sandibiorientasipenggunaanslik";
export const SandiBiGovKreditApiPath = BASE_MASTER_FINANCE + "/sandibigovkredit";
export const SandiBiGolPenjaminApiPath = BASE_MASTER_FINANCE + "/sandibigolpenjamin";
export const SandiBiSifatApiPath = BASE_MASTER_FINANCE + "/sandibisifat";
export const SandiBiSektorEkonomiApiPath = BASE_MASTER_FINANCE + "/sandibisektorekonomi";
export const SandiBiKurApiPath = BASE_MASTER_FINANCE + "/sandibikur";
export const SandiBiP2plApiPath = BASE_MASTER_FINANCE + "/sandibip2pl";
export const SandiBiTksAtmrApiPath = BASE_MASTER_FINANCE + "/sandibitksatmr";
export const SandiBiIkatanHukumApiPath = BASE_MASTER_FINANCE + "/sandibiikatanhukum";
export const SandiBiLembagaRatingApiPath = BASE_MASTER_FINANCE + "/sandibilembagarating";
export const SandiBiJenisAgunanApiPath = BASE_MASTER_FINANCE + "/sandibijenisagunan";
export const SandiBiJenisAgunanSlikApiPath = BASE_MASTER_FINANCE + "/sandibijenisagunanslik";
export const SandiBiJenisDokumenApiPath = BASE_MASTER_FINANCE + "/sandibijenisdokumen";
export const SandiBiFasilitasSlikApiPath = BASE_MASTER_FINANCE + "/sandibifasilitasslik";
export const SandiBiGolDebiturApiPath = BASE_MASTER_FINANCE + "/sandibigoldebitur";
export const SandiBiGolKrediturApiPath = BASE_MASTER_FINANCE + "/sandibigolkreditur";
export const SandiBiGroupDebiturApiPath = BASE_MASTER_FINANCE + "/sandibigroupdebitur";
export const SandiBiJenisAkadApiPath = BASE_MASTER_FINANCE + "/sandibijenisakad";
export const SandiBiHubunganBankApiPath = BASE_MASTER_FINANCE + "/sandibihubunganbank";
export const SandiBiHubunganLjkSlikApiPath = BASE_MASTER_FINANCE + "/sandibihubunganljkslik";
export const SandiBiIkatanHukumSlikApiPath = BASE_MASTER_FINANCE + "/sandibiikatanhukumslik";
export const SandiBiLokasiApiPath = BASE_MASTER_FINANCE + "/sandibilokasi";
export const SandiBiPemilikApiPath = BASE_MASTER_FINANCE + "/sandibipemilik";
// Master Edu
export const EduPendidikanApiPath = BASE_MASTER_EDU + "/edupendidikan";
export const EduJabatanApiPath = BASE_MASTER_EDU + "/edujabatan";
export const EduProfesiApiPath = BASE_MASTER_EDU + "/eduprofesi";
export const EduPenilaianApiPath = BASE_MASTER_EDU + "/edupenilaian";
export const EduPembelajaranApiPath = BASE_MASTER_EDU + "/edupembelajaran";
export const EduLombaApiPath = BASE_MASTER_EDU + "/edulomba";
export const EduKelasApiPath = BASE_MASTER_EDU + "/edukelas";
export const EduUniversitasApiPath = BASE_MASTER_EDU + "/eduuniversitas";
export const EduJurusanApiPath = BASE_MASTER_EDU + "/edujurusan";
// Kalender Akademik
export const EduTahunAjaranApiPath = BASE_MASTER_EDU + "/edutahunajaran";
export const EduPeriodeApiPath = BASE_MASTER_EDU + "/eduperiode";
export const EduKaldikKategoriApiPath = BASE_MASTER_EDU + "/edukaldikkategori";
export const EduKaldikAgendaApiPath = BASE_MASTER_EDU + "/edukaldikagenda";
export const PortalEduKaldikAgendaApiPath = BASE_MASTER + "/edu/portal/kaldikagenda";
export const PortalEduLombaApiPath = BASE_MASTER + "/edu/portal/lomba";
// Blok Waktu (Sistem Jadwal)
export const EduBlokWaktuApiPath = BASE_MASTER_EDU + "/edublokwaktu";
export const PortalEduSmsJadwalApiPath = "/edu/sms/portal/jadwal";
export const PortalEduSmsJadwalBlokWaktuApiPath = BASE_MASTER + "/edu/portal/edublokwaktu";
/* =========================
 * MANAJEMEN MODULE
 * ========================= */
export const BASE_MANAJEMEN = "/manajemen/facade";
export const MenuApiPath = BASE_MANAJEMEN + "/manajemenmenu";
export const RoleApiPath = BASE_MANAJEMEN + "/manajemenrole";
export const UserApiPath = BASE_MANAJEMEN + "/manajemenuser";
export const AksesApiPath = BASE_MANAJEMEN + "/manajemenakses";
export const CabangApiPath = BASE_MANAJEMEN + "/manajemencabang";
export const DomainApiPath = BASE_MANAJEMEN + "/manajemendomain";
export const LembagaApiPath = BASE_MANAJEMEN + "/manajemenlembaga";
export const AkunApiPath = BASE_MANAJEMEN + "/manajemenakun";
export const AkunBranchApiPath = BASE_MANAJEMEN + "/manajemenakunbranch";
export const AkunCoaApiPath = BASE_MANAJEMEN + "/manajemenakuncoa";
export const AkunEmployeeApiPath = BASE_MANAJEMEN + "/manajemenakunemployee";
export const AkunProcessApiPath = BASE_MANAJEMEN + "/manajemenakunprocess";
export const AkunRekeningApiPath = BASE_MANAJEMEN + "/manajemenakunrekening";
export const AkunReportApiPath = BASE_MANAJEMEN + "/manajemenakunreport";
export const SysidApiPath = BASE_MANAJEMEN + "/manajemensysid";
export const ManajemenAreaApiPath = BASE_MANAJEMEN + "/manajemenarea";
export const ClosingApiPath = BASE_MANAJEMEN + "/manajemenclosing";
export const ManajemenHariApiPath = BASE_MANAJEMEN + "/manajemenhari";
export const ManajemenKelompokApiPath = BASE_MANAJEMEN + "/manajemenkelompok";
export const ManajemenTemplateApiPath = BASE_MANAJEMEN + "/manajementemplate";
/* =========================
 * CUSTOMER MODULE
 * ========================= */
export const BASE_CUSTOMER = "/customer";
export const BASE_CUSTOMER_NASABAH = BASE_CUSTOMER + "/facade";
export const NasabahApiPath = BASE_CUSTOMER_NASABAH + "/nasabah";
export const NasabahDomisiliApiPath = BASE_CUSTOMER_NASABAH + "/nasabahdomisili";
export const NasabahIndividuApiPath = BASE_CUSTOMER_NASABAH + "/nasabahindividu";
export const NasabahKoperasiApiPath = BASE_CUSTOMER_NASABAH + "/nasabahkoperasi";
export const NasabahPasanganApiPath = BASE_CUSTOMER_NASABAH + "/nasabahpasangan";
export const NasabahPekerjaanApiPath = BASE_CUSTOMER_NASABAH + "/nasabahpekerjaan";
export const NasabahPerusahaanApiPath = BASE_CUSTOMER_NASABAH + "/nasabahperusahaan";
export const NasabahRekeningApiPath = BASE_CUSTOMER_NASABAH + "/nasabahrekening";
export const NasabahSandibiApiPath = BASE_CUSTOMER_NASABAH + "/nasabahsandibi";
export const NasabahRelasiApiPath = BASE_CUSTOMER_NASABAH + "/nasabah-relasi";
export const NasabahRelasiTerkaitApiPath = NasabahRelasiApiPath + "/daftarnasabahterkait";
export const NasabahRelasiUtamaApiPath = NasabahRelasiApiPath + "/daftarnasabahutama";
/* =========================
 * FINANCE MODULE
 * ========================= */
export const BASE_FINANCE = "/finance";
// Finance Saving (Tabungan)
export const BASE_FINANCE_SAVING = BASE_FINANCE + "/saving/facade";
export const TabAccrualApiPath = BASE_FINANCE_SAVING + "/tabaccrual";
export const TabAmortisasiApiPath = BASE_FINANCE_SAVING + "/tabamortisasi";
export const TabBlokirApiPath = BASE_FINANCE_SAVING + "/tabblokir";
export const TabKodeTransApiPath = BASE_FINANCE_SAVING + "/tabkodetrans";
export const TabPpapApiPath = BASE_FINANCE_SAVING + "/tabppap";
export const TabProdukApiPath = BASE_FINANCE_SAVING + "/produk";
export const TabRekeningApiPath = BASE_FINANCE_SAVING + "/rekening";
export const TabSaldoApiPath = BASE_FINANCE_SAVING + "/saldo";
export const TabTransApiPath = BASE_FINANCE_SAVING + "/tabtrans";
// Finance Deposito
export const BASE_FINANCE_DEPOSITO = BASE_FINANCE + "/deposito/facade";
export const DepAccrualApiPath = BASE_FINANCE_DEPOSITO + "/depaccrual";
export const DepAmortisasiApiPath = BASE_FINANCE_DEPOSITO + "/depamortisasi";
export const DepAroApiPath = BASE_FINANCE_DEPOSITO + "/deparo";
export const DepBlokirApiPath = BASE_FINANCE_DEPOSITO + "/depblokir";
export const DepKodeTransApiPath = BASE_FINANCE_DEPOSITO + "/depkodetrans";
export const DepPpapApiPath = BASE_FINANCE_DEPOSITO + "/depppap";
export const DepProdukApiPath = BASE_FINANCE_DEPOSITO + "/produk";
export const DepRekeningApiPath = BASE_FINANCE_DEPOSITO + "/rekening";
export const DepSaldoApiPath = BASE_FINANCE_DEPOSITO + "/depsaldo";
export const DepTransApiPath = BASE_FINANCE_DEPOSITO + "/deptrans";
// Finance Loan (Kredit)
export const BASE_FINANCE_LOAN = BASE_FINANCE + "/loan/facade";
export const KreFosApiPath = BASE_FINANCE_LOAN + "/krefos";
export const KreLoanApiPath = BASE_FINANCE_LOAN + "/kreloan";
export const KreLoanAsuransiApiPath = BASE_FINANCE_LOAN + "/kreloanasuransi";
export const KreLoanAydaApiPath = BASE_FINANCE_LOAN + "/kreloanayda";
export const KreLoanDendaApiPath = BASE_FINANCE_LOAN + "/kreloandenda";
export const KreLoanPenjaminApiPath = BASE_FINANCE_LOAN + "/kreloanpenjamin";
export const KreLoanPensiunApiPath = BASE_FINANCE_LOAN + "/kreloanpensiun";
export const KreLoanPoApiPath = BASE_FINANCE_LOAN + "/kreloanpo";
export const KreLoanSandibiApiPath = BASE_FINANCE_LOAN + "/kreloansandibi";
export const KreLoanSindikasiApiPath = BASE_FINANCE_LOAN + "/kreloansindikasi";
export const KreRekeningApiPath = BASE_FINANCE_LOAN + "/krerekening";
export const KreRekeningJadwalApiPath = BASE_FINANCE_LOAN + "/krerekeningjadwal";
export const KreRekeningRestrukturApiPath = BASE_FINANCE_LOAN + "/krerekeningrestruktur";
export const KreRekeningSaldoApiPath = BASE_FINANCE_LOAN + "/krerekeningsaldo";
export const KreRekeningSkemaApiPath = BASE_FINANCE_LOAN + "/krerekeningskema";
export const KreRekeningSukuBungaApiPath = BASE_FINANCE_LOAN + "/krerekeningsukubunga";
export const KreProdukApiPath = BASE_FINANCE_LOAN + "/kreproduk";
export const KreProdukCoaApiPath = BASE_FINANCE_LOAN + "/kreprodukcoa";
export const KreProdukDendaApiPath = BASE_FINANCE_LOAN + "/kreprodukdenda";
export const KreProdukFosApiPath = BASE_FINANCE_LOAN + "/kreprodukfos";
export const KreProdukScaleApiPath = BASE_FINANCE_LOAN + "/kreprodukscale";
export const KreProdukShuApiPath = BASE_FINANCE_LOAN + "/kreprodukshu";
export const KreProdukSkemaApiPath = BASE_FINANCE_LOAN + "/kreprodukskema";
export const ColateralApiPath = BASE_FINANCE_LOAN + "/colateral";
export const ColateralDokumenApiPath = BASE_FINANCE_LOAN + "/colateraldokumen";
export const ColateralDokumenHistApiPath = BASE_FINANCE_LOAN + "/colateraldokumenhist";
export const ColateralSandiBiApiPath = BASE_FINANCE_LOAN + "/colateralsandibi";
// Finance Teller
export const BASE_TELLER = BASE_FINANCE + "/teller/facade";
export const TellerApprovalApiPath = BASE_TELLER + "/teller/approval";
export const TellerDnominasiApiPath = BASE_TELLER + "/teller/dnominasi";
export const TellerKodeTransApiPath = BASE_TELLER + "/teller/kodetrans";
export const TellerRequestApiPath = BASE_TELLER + "/teller/request";
export const TellerSaldoApiPath = BASE_TELLER + "/teller/saldo";
export const TellerTransApiPath = BASE_TELLER + "/teller/trans";
export const TellerKreditApiPath = BASE_TELLER + "/teller/kredit";
/* =========================
 * ACCOUNTING MODULE (ACC)
 * ========================= */
export const BASE_AKUNTANSI = "/acc";
// Accounting Ledger (Pembukuan)
export const BASE_AKUNTANSI_PEMBUKUAN = BASE_AKUNTANSI + "/ledger/facade";
export const AccCoaApiPath = BASE_AKUNTANSI_PEMBUKUAN + "/acccoa";
export const AccJurnalApiPath = BASE_AKUNTANSI_PEMBUKUAN + "/accjurnal";
export const AccSaldoApiPath = BASE_AKUNTANSI_PEMBUKUAN + "/accsaldo";
// Accounting Assets (Aset)
export const BASE_AKUNTANSI_INV = BASE_AKUNTANSI + "/assets/facade";
export const InvKodeTransApiPath = BASE_AKUNTANSI_INV + "/kodetrans";
export const InvProdukApiPath = BASE_AKUNTANSI_INV + "/produk";
export const InvRekeningApiPath = BASE_AKUNTANSI_INV + "/rekening";
export const InvSaldoApiPath = BASE_AKUNTANSI_INV + "/saldo";
export const InvTransApiPath = BASE_AKUNTANSI_INV + "/trans";
// Accounting RRA
export const BASE_AKUNTANSI_RRA = BASE_AKUNTANSI + "/rra/facade";
export const RraKodeTransApiPath = BASE_AKUNTANSI_RRA + "/kodetrans";
export const RraProdukApiPath = BASE_AKUNTANSI_RRA + "/produk";
export const RraRekeningApiPath = BASE_AKUNTANSI_RRA + "/rekening";
export const RraSaldoApiPath = BASE_AKUNTANSI_RRA + "/saldo";
export const RraTransApiPath = BASE_AKUNTANSI_RRA + "/trans";
// Accounting RRP
export const BASE_AKUNTANSI_RRP = BASE_AKUNTANSI + "/rrp/facade";
export const RrpKodeTransApiPath = BASE_AKUNTANSI_RRP + "/kodetrans";
export const RrpProdukApiPath = BASE_AKUNTANSI_RRP + "/produk";
export const RrpRekeningApiPath = BASE_AKUNTANSI_RRP + "/rekening";
export const RrpSaldoApiPath = BASE_AKUNTANSI_RRP + "/saldo";
export const RrpTransApiPath = BASE_AKUNTANSI_RRP + "/trans";
/* =========================
 * EDUCATION MODULE (EDU)
 * ========================= */
export const BASE_EDU = "/edu";
export const BASE_EDU_SMS = BASE_EDU + "/sms/facade";
// SMS Dashboard
export const SMS_DASHBOARD = BASE_EDU_SMS + "/dashboard";
export const EduDashboardSummaryApiPath = SMS_DASHBOARD + "/summary";
export const EduDashboardStudentTalentsApiPath = SMS_DASHBOARD + "/student-talents";
// SMS Pengaturan
export const SMS_PENGATURAN = BASE_EDU_SMS + "/pengaturan";
export const SmsDataRombelApiPath = SMS_PENGATURAN + "/datarombel";
export const SmsEduRombonganBelajarApiPath = SMS_PENGATURAN + "/datarombel";
export const SmsDataMapelApiPath = SMS_PENGATURAN + "/datamapel";
export const SmsDataRppApiPath = SMS_PENGATURAN + "/datarpp";
export const SmsRppDetailApiPath = SMS_PENGATURAN + "/rppdetail";
export const SmsRppTopicApiPath = SMS_PENGATURAN + "/rpptopic";
export const SmsRppMeetingApiPath = SMS_PENGATURAN + "/rppmeeting";
export const SmsScoringApiPath = SMS_PENGATURAN + "/scoring";
// SMS Jurnal
export const SMS_JURNAL = BASE_EDU_SMS + "/jurnal";
export const JurnalKbmHeaderApiPath = SMS_JURNAL + "/kbmheader";
export const JurnalKbmDetailApiPath = SMS_JURNAL + "/kbmdetail";
export const JurnalKonselingApiPath = SMS_JURNAL + "/konseling";
export const JurnalMonitoringApiPath = SMS_JURNAL + "/monitoring";
export const JurnalMutabaahHeaderApiPath = SMS_JURNAL + "/mutabaahheader";
export const JurnalMutabaahDetailApiPath = SMS_JURNAL + "/mutabaahdetail";
export const JurnalTaskHeaderApiPath = SMS_JURNAL + "/taskheader";
export const JurnalTaskDetailApiPath = SMS_JURNAL + "/taskdetail";
export const JurnalTryoutHeaderApiPath = SMS_JURNAL + "/tryoutheader";
export const JurnalTryoutDetailApiPath = SMS_JURNAL + "/tryoutdetail";
export const JurnalPrestasiLombaApiPath = SMS_JURNAL + "/prestasilomba";
// SMS Laporan
export const SMS_LAPORAN = BASE_EDU_SMS + "/laporan";
export const SmsLaporanJurnalKbmApiPath = SMS_LAPORAN + "/jurnalkbm";
export const SmsLaporanPresensiApiPath = SMS_LAPORAN + "/presensi";
export const SmsLaporanJurnalKonselingApiPath = SMS_LAPORAN + "/jurnalkonseling";
export const SmsLaporanJurnalMonitoringApiPath = SMS_LAPORAN + "/jurnalmonitoring";
export const SmsLaporanJurnalMutabaahApiPath = SMS_LAPORAN + "/jurnalmutabaah";
export const SmsLaporanJurnalTaskApiPath = SMS_LAPORAN + "/jurnaltask";
export const SmsLaporanRaporEvaluasiApiPath = SMS_LAPORAN + "/raporevaluasi";
export const SmsLaporanTryoutApiPath = SMS_LAPORAN + "/tryout";
export const SmsCatatanEvaluasiApiPath = SmsLaporanRaporEvaluasiApiPath + "/catatanevaluasi";
export const EduSiswaTargetPtnApiPath = BASE_EDU_SMS + "/targetptn";
// SMS Data Jadwal
export const SmsJadwalKbmApiPath = SMS_PENGATURAN + "/jadwalkbm";
export const SmsJadwalMutabaahApiPath = SMS_PENGATURAN + "/jadwalmutabaah";
export const SmsJadwalPiketApiPath = SMS_PENGATURAN + "/jadwalpiket";
// Portal SMS Endpoints
export const PORTAL_EDU_SMS = BASE_EDU + "/sms/portal";
export const PortalJurnalKbmApiPath = PORTAL_EDU_SMS + "/jurnalkbm";
export const PortalJurnalTaskApiPath = PORTAL_EDU_SMS + "/jurnaltask";
export const PortalJurnalMutabaahApiPath = PORTAL_EDU_SMS + "/jurnalmutabaah";
export const PortalJurnalMonitoringApiPath = PORTAL_EDU_SMS + "/jurnalmonitoring";
export const PortalEduPrestasiLombaApiPath = PORTAL_EDU_SMS + "/jurnalprestasilomba";
export const PortalJurnalKonselingApiPath = PORTAL_EDU_SMS + "/jurnalkonseling";
export const PortalLaporanTryoutApiPath = PORTAL_EDU_SMS + "/laporan/tryout";
export const PortalLaporanRaporApiPath = PORTAL_EDU_SMS + "/laporan/rapor";
export const PortalLaporanPresensiKbmApiPath = PORTAL_EDU_SMS + "/laporan/presensi-kbm";
export const PortalLaporanPresensiMutabaahApiPath = PORTAL_EDU_SMS + "/laporan/presensi-mutabaah";
/* =========================
 * ASSESSMENT MODULE (EDU)
 * ========================= */
export const BASE_EDU_ASSESSMENT = BASE_EDU + "/assessment/facade";
// Master/Config
export const AssessmentJenisUjianApiPath = BASE_EDU_ASSESSMENT + "/jenisujian";
export const AssessmentTipeSoalApiPath = BASE_EDU_ASSESSMENT + "/tipesoal";
// Bank Soal
export const AssessmentSoalApiPath = BASE_EDU_ASSESSMENT + "/soal";
export const AssessmentSoalPilihanApiPath = BASE_EDU_ASSESSMENT + "/soalpilihan";
// Paket
export const AssessmentPaketApiPath = BASE_EDU_ASSESSMENT + "/paketujian";
export const AssessmentPaketSoalApiPath = BASE_EDU_ASSESSMENT + "/paketsoal";
// Sesi & Ujian
export const AssessmentSesiApiPath = BASE_EDU_ASSESSMENT + "/sesiujian";
export const AssessmentSesiPesertaApiPath = BASE_EDU_ASSESSMENT + "/sesipeserta";
export const AssessmentJawabanApiPath = BASE_EDU_ASSESSMENT + "/jawabansiswa";
// Portal (siswa)
export const PORTAL_ASSESSMENT = BASE_EDU + "/assessment/portal";
export const PortalAssessmentSesiApiPath = PORTAL_ASSESSMENT + "/sesi-aktif";
export const PortalAssessmentMulaiApiPath = PORTAL_ASSESSMENT + "/mulai";
export const PortalAssessmentJawabanApiPath = PORTAL_ASSESSMENT + "/jawaban";
export const PortalAssessmentSubmitApiPath = PORTAL_ASSESSMENT + "/submit";
export const PortalAssessmentHasilApiPath = PORTAL_ASSESSMENT + "/hasil";
/* =========================
 * ACADEMY MODULE (EDU)
 * ========================= */
export const BASE_EDU_ACADEMY = BASE_EDU + "/academy/facade";
// Master/Config
export const AcademyKategoriApiPath = BASE_EDU_ACADEMY + "/kategori";
export const AcademyKursusApiPath = BASE_EDU_ACADEMY + "/kursus";
export const AcademyBabApiPath = BASE_EDU_ACADEMY + "/bab";
export const AcademyMateriApiPath = BASE_EDU_ACADEMY + "/materi";
export const AcademyEnrollmentApiPath = BASE_EDU_ACADEMY + "/enrollment";
export const AcademySubmissionApiPath = BASE_EDU_ACADEMY + "/submission";
export const AcademySertifikatApiPath = BASE_EDU_ACADEMY + "/sertifikat";
export const AcademyDiskusiApiPath = BASE_EDU_ACADEMY + "/diskusi";
export const AcademyLaporanApiPath = BASE_EDU_ACADEMY + "/laporan";
export const AcademyKuisApiPath = BASE_EDU_ACADEMY + "/kuis";
export const AcademyKuisMateriApiPath = AcademyKuisApiPath + "/materi";
// Portal (siswa)
export const PORTAL_ACADEMY = BASE_EDU + "/academy/portal";
export const PortalAcademyKatalogApiPath = PORTAL_ACADEMY + "/katalog";
export const PortalAcademyKursusApiPath = PORTAL_ACADEMY + "/kursus";
export const PortalAcademyEnrollApiPath = PORTAL_ACADEMY + "/enroll";
export const PortalAcademyLearnApiPath = PORTAL_ACADEMY + "/learn";
export const PortalAcademyProgressApiPath = PORTAL_ACADEMY + "/progress";
export const PortalAcademySubmitApiPath = PORTAL_ACADEMY + "/submit";
export const PortalAcademySertifikatApiPath = PORTAL_ACADEMY + "/sertifikat";
export const PortalAcademyKuisApiPath = PORTAL_ACADEMY + "/kuis";
export const PortalAcademyKuisMateriApiPath = PortalAcademyKuisApiPath + "/materi";
export const PortalAcademyKuisSubmitApiPath = PortalAcademyKuisApiPath + "/submit";
export const PortalAcademyKuisHistoryApiPath = PortalAcademyKuisApiPath + "/history";
export const PortalAcademyDiskusiApiPath = PORTAL_ACADEMY + "/diskusi";
export const PortalAcademyEnrollmentsApiPath = PORTAL_ACADEMY + "/enrollments";
